const Status = {
    received: 'RECEIVED',
    inReview: 'IN_REVIEW',
    declined: 'DECLINED',
    completed: 'COMPLETED',
}

export default Status
